import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Badge } from '@/components/ui/Badge';
import { useActiveLease } from '@/hooks/useLeases';
import { useQuery } from '@tanstack/react-query';
import { inspectionsApi } from '@/api/inspections';
import { formatDate } from '@/utils/format';

export function InspectionsPage() {
  const { t } = useTranslation();
  const { activeLease } = useActiveLease();
  const insp = useQuery({
    queryKey: ['inspections', activeLease?.id],
    queryFn: () =>
      inspectionsApi.list(activeLease ? { lease_id: activeLease.id } : undefined),
    enabled: Boolean(activeLease),
  });

  if (insp.isLoading) return <Spinner />;

  return (
    <Card title={t('inspections.title')}>
      {insp.data && insp.data.length > 0 ? (
        <ul className="divide-y divide-slate-100">
          {insp.data.map((i) => (
            <li key={i.id} className="flex items-center justify-between py-3 text-sm">
              <div>
                <p className="font-medium">
                  {i.performed_at ? formatDate(i.performed_at) : '—'}
                </p>
                {i.notes ? <p className="text-xs text-slate-500">{i.notes}</p> : null}
              </div>
              <Badge tone="info">{t(`inspections.status.${i.status}`)}</Badge>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
